import * as React from "react";
import { useState, useEffect } from "react";
import { Alert } from "@mui/material";
import { useNavigate, useParams } from 'react-router-dom'
import { Form, Row, Col, Button, Card } from "react-bootstrap";
import jwt_decode from 'jwt-decode';
import axios from 'axios'

const SetPassword = () => {
    const [password, setPassword] = useState("");
    const [cPassword, setCPassword] = useState("");
    const [success, setSuccess] = useState('');
    const [errors, setError] = useState("");
    const [validUrl, setValidUrl] = useState(false);
    const navigate = useNavigate();
    const { token } = useParams();

    useEffect(() => {
        const userToken = token;
        const currentDate = new Date();
        const decodedToken = jwt_decode(userToken);
        if (decodedToken.exp * 1000 < currentDate.getTime()) {
            setValidUrl(false)
        } else {
            setValidUrl(true)
        }
    }, [validUrl, token])

    const handleSubmit = async(e) => {
        e.preventDefault();
        try {
            await axios.post(process.env.REACT_APP_FIND_API_URL + `/auth/set-password/${token}`, {
                seller_profile_password: password,
                cpassword: cPassword
            }).then((res)=> {
                setSuccess(res.data.message);
                navigate('/login')
            })
        } catch (error) {
            setError(error.response.data.message)
        }
    }
    return (
        <div style={{ height: '75vh' }} className={`d-flex justify-content-center align-items-center`}>
            <Card style={{ width: '450px' }} className="border-0 py-5">
                <Form onSubmit={handleSubmit}>
                    <h1 className="text-center pb-3">Set Password</h1>
                    <h5 className="text-center pb-3">Welcome to FindNow!</h5>
                    {validUrl ? (<>

                        {errors && <Alert severity="error">{errors}</Alert>}
                    </>

                    ) : (<>
                        {errors && <Alert severity="error">{errors}</Alert>}
                        {success && <Alert severity="success">{success}</Alert>}
                        <Alert severity="error">* Your Link has Expired</Alert>
                    </>)}
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>New Password</Form.Label>
                                <Form.Control type="password" placeholder="Enter Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control type="password" placeholder="Enter Password" value={cPassword} onChange={(e) => setCPassword(e.target.value)} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="my-4">
                        <Button variant="primary" type="submit" className="w-100">
                            Submit
                        </Button>
                    </div>
                </Form>
            </Card>
        </div>
    );
}

export default SetPassword;